
const testimonialsData = [
  {
    id: 1,
    name: "Vincent W",
    location: "Holy Spirit, Union Nj",
    position: "Parish Leader",
    text: "Right before I was asked to be Parish Leader, I was asking God what more I could do for my faith, my spiritual journey.  I had recently become a Eucharistic Minister for our Parish and I have been a member of our Soup Kitchen ministry for many years, but I felt like there was more I needed to do.  I just didn't know what.\n\nThen, the telephone rang and I saw it was Cathy Drake.  I thought, 'What does she want?  She probably wants to know if I plan on bringing my youngest son back to CCD next year.'  I NEVER expected to be asked to be a Parish Leader of a new ministry.  It took me some time to understand what this ministry was about and what I was asked to do.  I could not even understand the name of the ministry.\n\nBut, after studying the materials and after several texts, e-mails, and telephone conversations with Ms. Drake, I finally began to understand what I needed to do.  I need to put together a team?  I need to plan various events?  I need to speak to people I do not know?  ---  I do not do any of these things well....or at all, but I did it because God told me this was my next step in my spiritual journey.  I am happy to say that I not only listened to God, but I said, 'Yes,' to God and this ministry!\n\nBecause of this ministry and the wonderful team we have at Holy Spirit Church, I have become more confident with my faith and sharing it with others, our parish, our priests, and all the great ministries.  Sundays have become my favorite day of the week simply because of the Eucharist, and I owe it to Beyond Baptism!  Beyond Baptism has been my aha moment.",
  },

  {
    id: 2,
    name: "George",
    location: "St Catherine of Sienna Caldwell, NJ",
    position: "",
    text: "I am retired and consider myself a cradle Catholic. I go to church and celebrate Mass every Sunday. I hope I can speak for everyone in this room, I can no longer walk up to the Altar and receive the Eucharist in the same way after witnessing 4 sessions with Beyond Baptism.",
  },

  {
    id: 3,
    name: "Rita",
    location: "St Rocco’s/St Bridget Parish, Union City NJ",
    position: "Parish Leader",
    text: "As a Beyond Baptism Leader at my Parish, I have learned so much from the program. In the past I did not think about what I would wear to Mass,  Now I plan my outfit out so I can see the Lord at Mass. It is changing everything for me. Plus to see and witness our guests just sit and want to talk about the Eucharist is so rewarding. We feel like we are helping the Pastor and his flock.",
  },

  {
    id: 4,
    name: "Suzie",
    location: "St Rocco’s/ St Bridget Union City, NJ",
    position: "",
    text: "I love my faith and Beyond Baptism has taught us so much that we did not know. The leader stated that she hopes that Beyond Baptism  gives you enough information to feel comfortable to defend your faith. I felt so blessed when she said that, because that was going through my head while watching the videos. In the past, I felt like I was fighting with others when they asked about Catholicism. I drive an hour each way to get to the session!!",
  },

  {
    id: 5,
    name: "Joe",
    location: "OLMC Lyndhurst NJ",
    position: "",
    text: "Beyond Baptism provides videos that are short and easy to understand, it feels great to walk out and be able to strike up a conversation about my faith.",
  },

  {
    id: 6,
    name: "Anna",
    location: "St Theresa Kenilworth, NJ",
    position: "",
    text: "This is amazing, can I bring it to my parish?",
  },

  {
    id: 7,
    name: "Evanagelina",
    location: "Holy Spirit Parish Union NJ",
    position: "",
    text: "Thank you for letting the confirmation class come to a Beyond Baptism session. This is a different way of learning about our faith. It was nice to be with the adults and then to be able to hear what they think and they listen to what we said about the videos. Can we come all the time??",
  },

  {
    id: 8,
    name: "Gabe",
    location: "OLMC, Lyndhurst, N.J.",
    position: "",
    text: "As a Leader of Beyond Baptism, this has been most rewarding. Listening to everyone’s response at the end of each session confirms why I agreed to be the leader. Being able to bring the parishioners information that they can learn from and have a personal relationship with Jesus is amazing. I want help on how we can grow this at each church.",
  },

  {
    id: 9,
    name: "Russel",
    location: "Knights of Columbus",
    position: "State Treasurer",
    text: "I promoted this program throughout the Knights of Columbus in New Jersey. It is an easy program, turn key if you will. They do all the marketing, the training and coaching. The parish events are in a detailed manual easy to understand, pariah announcements to food donation letters for the events are all included. Best of all, succession planning, they only ask you to serve for 2 years.",
  },

  {
    id: 10,
    name: "Betty",
    location: "Hackensack, N.J.",
    position: "Holy Trinity Parish",
    text: "I love the questions and answers at the end of each event. A few times there is a question that says what was your aha moment while watching the films, I have to say there is so much to witness that I have an aha moment each time. Thank you Beyond Baptism!!",
  },

  {
    id: 11,
    name: "Patti C.",
    location: "Hackensack, N.J.",
    position: "Holy Trinity Parish",
    text: "When I first heard of Beyond Baptism's mission I was very surprised to hear how many Catholics do not believe in the Real Presence. The Beyond Baptism events I've attended were all so informative and eye opening. I would be shocked if any non-believer would still not believe after having participated in Beyond Baptism.",
  },

  {
    id: 12,
    name: "Shannon Coyle",
    location: "Beyond Baptism Volunteer",
    position: "Content Writer",
    text: "I feel so blessed to be part of the Beyond Baptism team. The knowledge I have gained through each experience I've had with Beyond Baptism is such a gift. Most importantly this experience has strengthened my belief and helped me to see Christ in not only the Eucharist but also everyone around me. We are the hands and feet of Christ. I'm reminded of that every time I am blessed to be at a Beyond Baptism event, working on one of our projects or with a fellow team member.",
  },

  {
    id: 13,
    name: "Diane B.",
    location: "",
    position: "Diocesan Leader",
    text: "It is such a blessing to see the Parish Leaders and Parish Ministers of the various parishes involved in the Beyond Baptism program join together as a spirit filled team planning and executing the mission of leading others to the joy of knowing more about the Eucharistic experience. The movement of the Holy Spirit is working through the team and the participants of the Beyond Baptism events aiding all to increase their reverence, reception and relationship with  Our Lord Jesus Christ. Come Holy Spirit, come and lead us to the love of the Eucharist.",
  },
];

export default testimonialsData;